/*
 * SOKUDO UNIVERSE ENGINE
 * Global theme state, character animations, boot sequence, and AJAX cart.
 */

class SokudoEngine {
  constructor() {
    this.activeTheme = localStorage.getItem('sokudoTheme') || 'wheelie';
    this.init();
  }

  init() {
    this.applyTheme(this.activeTheme);
    this.bindEvents();
  }

  applyTheme(themeName) {
    document.body.className = `theme-active-${themeName}`;
  }

  setTheme(themeName) {
    this.activeTheme = themeName;
    localStorage.setItem('sokudoTheme', themeName);
    this.applyTheme(themeName);
  }

  bindEvents() {
    // Theme triggers
    document.querySelectorAll('[data-theme-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.setTheme(trigger.dataset.themeTrigger);
      });
    });

    // Cart Drawer — always refresh content before opening so cart items are visible
    const cartToggle = document.querySelector('.cart-toggle-btn');
    if (cartToggle) {
      cartToggle.addEventListener('click', () => {
        const cartDrawer = document.getElementById('CartDrawer');
        const isOpen = cartDrawer && !cartDrawer.classList.contains('hidden');
        if (isOpen) {
          if (window.CartDrawer) window.CartDrawer.close();
          else if (cartDrawer) cartDrawer.classList.add('hidden');
        } else {
          if (window.CartDrawer) window.CartDrawer.open();
          else if (cartDrawer) cartDrawer.classList.remove('hidden');
        }
      });
    }

    // Menu Drawer
    const menuToggle = document.querySelector('.menu-toggle-btn');
    const menuDrawer = document.getElementById('MenuDrawer');
    const closeMenu = document.querySelector('.close-menu-btn');
    if (menuToggle && menuDrawer) {
      menuToggle.addEventListener('click', () => menuDrawer.classList.toggle('hidden'));
    }
    if (closeMenu && menuDrawer) {
      closeMenu.addEventListener('click', () => menuDrawer.classList.add('hidden'));
    }

    // Cart count live refresh — fires when garage AJAX add dispatches cart:updated
    document.addEventListener('cart:updated', () => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = `[${cart.item_count}]`;
          });
        });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.SokudoEngine = new SokudoEngine();
});
